var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "editor-container" } },
    [
      _vm.currentSession && _vm.active
        ? _c("div", [
            _vm.hasSyncCollission
              ? _c("p", { staticClass: "msg icon-error" }, [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.t(
                          "text",
                          "The document has been changed outside of the editor. The changes cannot be applied."
                        )
                      ) +
                      "\n\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.hasConnectionIssue
              ? _c("p", { staticClass: "msg icon-info" }, [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.t(
                          "text",
                          "File could not be loaded. Please check your internet connection."
                        )
                      ) +
                      " "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "button primary",
                      on: { click: _vm.reconnect }
                    },
                    [_vm._v(_vm._s(_vm.t("text", "Retry")))]
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentSession && _vm.active
        ? _c(
            "div",
            {
              class: {
                "has-conflicts": _vm.hasSyncCollission,
                "icon-loading": !_vm.initialLoading || _vm.hasConnectionIssue,
                richEditor: _vm.isRichEditor
              },
              attrs: { id: "editor-wrapper" }
            },
            [
              _c(
                "div",
                { attrs: { id: "editor" } },
                [
                  !_vm.syncError && !_vm.readOnly
                    ? _c(
                        "MenuBar",
                        {
                          ref: "menubar",
                          attrs: {
                            editor: _vm.tiptap,
                            "is-rich-editor": _vm.isRichEditor,
                            "is-public": _vm.isPublic,
                            autohide: _vm.autohide
                          }
                        },
                        [
                          _vm.currentSession && _vm.active
                            ? _c(
                                "div",
                                { attrs: { id: "editor-session-list" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.lastSavedStatusTooltip,
                                          expression: "lastSavedStatusTooltip"
                                        }
                                      ],
                                      staticClass: "save-status",
                                      class: _vm.lastSavedStatusClass
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(_vm.lastSavedStatus) +
                                          "\n\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "SessionList",
                                    {
                                      attrs: { sessions: _vm.filteredSessions }
                                    },
                                    [
                                      _vm.isPublic &&
                                      _vm.currentSession.guestName
                                        ? _c("GuestNameDialog", {
                                            attrs: {
                                              "sync-service": _vm.syncService
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("header")
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      !_vm.readOnly && _vm.isRichEditor
                        ? _c("MenuBubble", { attrs: { editor: _vm.tiptap } })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("EditorContent", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.initialLoading,
                            expression: "initialLoading"
                          }
                        ],
                        staticClass: "editor__content",
                        attrs: { editor: _vm.tiptap }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasSyncCollission
                ? _c("ReadOnlyEditor", {
                    attrs: {
                      content: _vm.syncError.data.outsideChange,
                      "is-rich-editor": _vm.isRichEditor
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasSyncCollission && !_vm.readOnly
        ? _c("CollisionResolveDialog", {
            on: {
              resolveUseThisVersion: _vm.resolveUseThisVersion,
              resolveUseServerVersion: _vm.resolveUseServerVersion
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }